// extracted by mini-css-extract-plugin
export default {"card":"partnership-analytics-card--card--Kq57jnjv","statCol":"partnership-analytics-card--statCol--EOcOxM08"};